import CampaignResults from './components/CampaignResultsPrint';
import './assets/CampaignResultsPrint.css';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import values from 'lodash/values';
import get from 'lodash/get';
import withRouter from 'react-router-dom/withRouter';

import { loadEngagementsForCampaign } from '../../shared/redux/entities/actions';

import { loadKPIsForCampaign } from '../../shared/redux/kpis/actions';

import { getEngagementsWithKPIs } from '../../shared/redux/selectors';

function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId ? props.match.params.campaignId : props.campaignId,
  campaign = get(state,['entities','campaigns',campaignId],{});

  let obj = {
    campaignId:campaignId,
    campaignName:campaign.name,
    campaignUseCTA:campaign.useCTA,
    salesNumber:campaign.salesNumber,
    brandName:get(state,['entities','companies',campaign.companyId,'name']),
    launchDate:campaign.launchDate,
    endDate:campaign.endDate,
    engagements:values(state.entities.engagements).filter((e) => e.campaignId === campaignId),
    engagementKPIs:get(state,['kpis','campaigns',campaignId,'engagementKPIs'],[]),
    averageTime:get(state,['kpis','campaigns',campaignId,'averageTime'],null),
    totalTimeSpent:get(state,['kpis','campaigns',campaignId,'totalTimeSpent'],null),
    totalCompletions:get(state,['kpis','campaigns',campaignId,'totalCompleted'],null),
    totalCtaClickCount:get(state,['kpis','campaigns',campaignId,'totalCtaClickCount'],null),
    engagementsWithKPIs:getEngagementsWithKPIs(state)
  };
  obj.totalEngagements = 0;
  for(let eng of obj.engagementKPIs) {
    obj.totalEngagements += eng.responsesNum;
  }
  obj.totalEngagementsCounted = obj.totalCompletions * obj.engagements.length
  obj.ctRate = obj.totalCompletions ? ((obj.totalCtaClickCount / obj.totalCompletions) * 100).toFixed(2) : 0;
  return obj;
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadEngagementsForCampaign,
    loadKPIsForCampaign
  },dispatch);
}


export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CampaignResults));



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/index.js